"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultiSelectInputList_1 = require("./MultiSelectInputList");
exports.default = MultiSelectInputList_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/MultiSelectInput/components/MultiSelectInputList/index.js
// module id = 382
// module chunks = 8